import { lazy, Suspense } from 'react'

import {
  StepVariants,
  type StepComponentContainer,
  type SummaryStepPrerequisiteDataDCC,
} from '@ngb-frontend/shared/types'
import { FullScreenLoader } from '@ngb-frontend/shared/ui'
import { hasSelectServiceLocationStepValues } from '@ngb-frontend/shared/utils'

const SummaryStepLazy = lazy(() => import('./SummaryStep'))

export const SummaryStepContainer: StepComponentContainer<
  object,
  SummaryStepPrerequisiteDataDCC
> = (props) => {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <SummaryStepLazy {...props} />
    </Suspense>
  )
}

SummaryStepContainer.areStepPrerequisitesMet = (
  mergedFlowData,
): mergedFlowData is SummaryStepPrerequisiteDataDCC =>
  hasSelectServiceLocationStepValues(mergedFlowData)

SummaryStepContainer.getVariant = () =>
  window.location.search ? StepVariants.Overview : StepVariants.Summary
